module.exports = __webpack_public_path__ + "static/f3-e340e362db7d569c3d1e9959f64a7f4c.jpeg";